import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useAccumulationCode from "./hooks/useAccumulationCode";

const AccumulationCode = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
}) => {
  const accumulationCodeData = useAccumulationCode(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData
  );

  return (
    <div className="container container-fluid">
      <ButtonsSection
        ctaButtons={accumulationCodeData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {accumulationCodeData.screen_title} -{" "}
          <span className="heading-cod">
            {accumulationCodeData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={accumulationCodeData.formFields}
        dropdownValues={accumulationCodeData.dropdownValues}
        paramsData={accumulationCodeData.paramsData}
        updataParamData={accumulationCodeData.updateParamData}
        disabledDropdowns={accumulationCodeData.disabledDropdowns}
      />
      <ButtonsSection ctaButtons={accumulationCodeData.ctaButtons} />
      <DisplayTable
        selectMode={accumulationCodeData.selectMode}
        data={accumulationCodeData.data}
        parmKey={accumulationCodeData.parmKey}
        menuOptions={accumulationCodeData.menuOptions}
        tableHeaders={accumulationCodeData.columnDef}
        setRowData={accumulationCodeData.setRowData}
        selectedPriceSchedules={accumulationCodeData.selectedRows}
        setSelectedPriceSchedules={accumulationCodeData.setSelectedRows}
        displayMode = {accumulationCodeData.displayMode}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={accumulationCodeData.first}
          rows={accumulationCodeData.rows}
          totalRecords={accumulationCodeData.totalRecords}
          currentPage={accumulationCodeData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={accumulationCodeData.onPageChange}
        />
      </div>
      {accumulationCodeData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={accumulationCodeData.isConfirmationModalOpen}
          onRequestClose={accumulationCodeData.closeConfirmationModal}
          onBack={accumulationCodeData.closeConfirmationModal}
          onSave={accumulationCodeData.deleteAccumulationCode}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={accumulationCodeData.setSelectedOption}
        />
      )}
      {accumulationCodeData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={accumulationCodeData.isHideConfirmationModalOpen}
          onRequestClose={accumulationCodeData.closeHideConfirmationModal}
          onBack={accumulationCodeData.closeHideConfirmationModal}
          onSave={accumulationCodeData.hideAccumulationCode}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={accumulationCodeData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default AccumulationCode;
